import AOS from 'aos'

class Animation {
    constructor() {
        AOS.init({
            duration: 600,
            once: true,
        });
    }
}

export { Animation }
